// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zkq8","title":"styles_title__CnljB"};